import { Component, ElementRef, HostListener, computed, input, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-user-menu',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.scss'
})
export class UserMenuComponent {
  userName = input<string | null>(null);
  userEmail = input<string | null>(null);
  userRoles = input<string[]>([]);

  logoutClick = output<void>();

  expanded = signal(false);

  initials = computed(() => {
    const name = this.userName()?.trim();
    if (!name) {
      return 'U';
    }
    return name
      .split(' ')
      .filter(part => part.length > 0)
      .map(part => part[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  });

  rolesLine = computed(() => {
    const roles = this.userRoles().filter(role => role.length > 0);
    if (roles.length === 0) {
      return 'User';
    }
    return roles.map(role => this.roleLabel(role)).join(', ');
  });

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  toggle(): void {
    this.expanded.update(open => !open);
  }

  logout(): void {
    this.expanded.set(false);
    this.logoutClick.emit();
  }

  @HostListener('document:click', ['$event'])
  closeOnOutsideClick(event: MouseEvent): void {
    if (!this.expanded()) {
      return;
    }
    const target = event.target;
    if (target instanceof Node && this.elementRef.nativeElement.contains(target)) {
      return;
    }
    this.expanded.set(false);
  }

  private roleLabel(role: string): string {
    const labels: Record<string, string> = {
      FirmAdmin: 'Firm Admin',
      Staff: 'Staff',
      Billing: 'Billing',
      LegalResourcesAdmin: 'LR Admin'
    };
    return labels[role] ?? role;
  }
}
